import React, { useState } from "react";
import { getOfferClaims } from "../../apiIntegration/getOfferDataFromFirebase";
import ClaimDetailsModal from "./ClaimDetailsModal";
import { formatOfferDate } from "../../constant/formatOfferDate";

const AdminOfferItem = ({ data, onDelete }) => {
	const [active, setActive] = useState(data.status === "active");
	const [claims, setClaims] = useState([]);
	const [loadingClaims, setLoadingClaims] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const handleClaimDetails = async () => {
		setShowModal(true);

		setLoadingClaims(true);

		const result = await getOfferClaims(data.offerId);

		setClaims(result);

		setLoadingClaims(false);
	};
	return (
		<div className="offer-item d-flex p-2">
			<div className="mr-1">
				<img src={data.image} alt={data.title} />
			</div>

			<div className="flex-grow-1 ms-3">
				<div className="d-flex justify-content-between">
					<div className="text-left">
						<h6>{data.title}</h6>
					</div>

					<div className="icons">
						<i
							className="fas fa-trash text-danger"
							onClick={onDelete}
							style={{
								cursor: "pointer",
							}}
						></i>
					</div>
				</div>
				<div className="text-left">
					<p className="text-muted mb-1">
						{data.category}{" "}
						<i class="fa-solid fa-arrow-right px-2"></i>{" "}
						{data.subCategory}
					</p>
				</div>

				<div className="text-left">
					<small className="start-end-date">
						<span className="pr-1">📅</span>
						{data.startDate
							? `Valid:  ${formatOfferDate(data.startDate)} - ${formatOfferDate(data.endDate)}`
							: `Valid: - ${formatOfferDate(data.endDate)}`}
					</small>
				</div>
				<div className="text-muted d-flex justify-content-between">
					<div>
						Claimed Count:
						{data.claimCount || 0}
					</div>
					<div className="pl-2">
						<button
							className="claim-details-btn"
							onClick={handleClaimDetails}
						>
							Claim Details
						</button>
					</div>
				</div>

				{/* <div className="d-flex justify-content-between align-items-center">
					<span className={active ? "text-success" : "text-muted"}>
						● {active ? "ACTIVE" : "INACTIVE"}
					</span>

					<div
						className={`toggle ${active ? "on" : ""}`}
						onClick={() => setActive(!active)}
					></div>
				</div> */}
			</div>
			<ClaimDetailsModal
				show={showModal}
				onClose={() => setShowModal(false)}
				claims={claims}
				loading={loadingClaims}
			/>
		</div>
	);
};

export default AdminOfferItem;
